import * as React from 'react';

import {Basic} from './Basic.story';

const basic = {
  rendered: <Basic />,
  source: `<Spinner size="small" />
<Spinner />
<Spinner size="large" />`,
};

export const SpinnerExamples = {
  basic,
};
